<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-lg-3 col-md-3 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-revenue-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'home'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Total inniver revenue</span>
              <h4 class="mt-0 mb-0"><span>$ {{totalRevenue | number : '1.0-2'}}</span></h4>
              <i class="icon-bg" data-feather="home"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-3 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-profit-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'activity'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Total inniver profit</span>
              <h4 class="mt-0 mb-0"><span>$ {{totalProfit | number:'1.2-2' }}</span></h4>
              <i class="icon-bg" data-feather="activity"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-3 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-pendingpayout-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'clock'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Pendig conversions</span>
              <h4 class="mt-0 mb-0"><span>$ {{pendingConversions | number : '1.0-2'}}</span></h4>
              <i class="icon-bg" data-feather="clock"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-3 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-paidtoday-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'shopping-cart'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Total to paid today</span>
              <h4 class="mt-0 mb-0"><span>$ {{totalToPaidToday | number : '1.0-2'}}</span></h4>
              <i class="icon-bg" data-feather="shopping-cart"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills" orientation="horizontal">

        <!-- TAB1 new request -->
        <ng-container ngbNavItem="payments">
          <button ngbNavLink>Payments</button>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="card">
                  <div class="card-body">
                    <table class="h6">
                      <tr>
                        <td style="text-align:right">
                          Today:
                        </td>
                        <td>
                          <b>{{currentDate | date:'d/MM/yyyy'}}</b>&nbsp;<small>({{currentDate | date:'EEEE'}})</small>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align:right">
                          Payday:
                        </td>
                        <td>
                          <b>{{PaymentsConfig.payday}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align:right">
                          Next payday:
                        </td>
                        <td>
                          <b *ngIf="nextpayDayDate!='Tomorrow' && nextpayDayDate!='Today'">{{nextpayDayDate | date:'d/MM/yyyy'}}</b>
                          <b *ngIf="nextpayDayDate=='Tomorrow'" class="blink blink-one">Tomorrow</b>
                          <b *ngIf="nextpayDayDate=='Today'" class="blink1">Today</b>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="col-lg-9 col-md-12 col-12">
                <div class="card">
                  <div class="card-body custom-datatable">
                <ngx-datatable
                class='bootstrap'
                [rows]="currentPayments"
                [columnMode]="ColumnMode.force"
                [limit]="page.size"
                [count]="page.totalElements"
                [offset]="page.pageNumber"
                [externalPaging]="true"
                (page)="setPage($event)"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                >
                <ngx-datatable-column name="Publisher"  [sortable]="true" prop="publisher.lastName">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Publisher</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a href="/adm/publishers/{{ row.publisher.id }}">{{ row.publisher.firstName }} {{ row.publisher.lastName }}</a>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="name"  [sortable]="true" prop="paymentTerm.name">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Payout term</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.paymentTerm.name }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Method" prop="payoutMethod.name">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Method</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.payoutMethod.name }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="amount">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Amount</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.amount | currency }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="paymentFee">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Payment fee</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.paymentFee | currency}}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="toPaid">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">To Paid</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.toPaid | currency }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="date">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Date</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.date | date:'d/M/yyyy' }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Status">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()"></span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                      <button class="btn btn-pill btn-xs btn-success" type="button" placement="top" ngbTooltip="pay or revert money" (click)="onPaid(row)">
                        Payout</button>
                  </ng-template>
                </ngx-datatable-column>

              </ngx-datatable>
              </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!-- TAB2 all request -->
        <ng-container ngbNavItem="allpayments">
          <button ngbNavLink>All Payments</button>
          <ng-template ngbNavContent>
            <div class="col-lg-12 col-md-12 col-12">
              <div class="card">
                <div class="card-body custom-datatable">
              <ngx-datatable
              class='bootstrap'
              [rows]="allPayments"
              [columnMode]="ColumnMode.flex"
              [limit]="pageAll.size"
              [count]="pageAll.totalElements"
              [offset]="pageAll.pageNumber"
              [externalPaging]="true"
              (page)="setPageAll($event)"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              >
              <ngx-datatable-column name="Date" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Date</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.date | date:'d/M/yyyy H:mm' }}
                </ng-template>
              </ngx-datatable-column> -->

              <ngx-datatable-column name="Invoice" [flexGrow]="2">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Invoice</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.invoiceNumber}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Publisher" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Publisher</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <a href="/adm/publishers/{{ row.publisher.id }}">{{ row.publisher.firstName }} {{ row.publisher.lastName }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="method" [flexGrow]="1" prop="prefferedPayoutMethod.name">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Method</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.prefferedPayoutMethod.name }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Status" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Status</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.payoutStatus.name}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="amount" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Amount</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.amount | currency }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="paymentFee" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Payment fee</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.paymentFee | currency}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Paid" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Paid out</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="row.payoutStatus.name!='Reverted'">{{ row.amount - row.paymentFee | currency }}</span>
                  <span *ngIf="row.payoutStatus.name=='Reverted'">{{ 0 | currency }}</span>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!-- TAB3 config -->
        <ng-container ngbNavItem="config">
          <button ngbNavLink>Config</button>
          <ng-template ngbNavContent>
            <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="card">
                <div class="card-body">
                  <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-5 col-form-label">Min $ withdrawal amount</label>
                    <div class="col-lg-1 col-md-2 col-2">
                        <input type="number" min="50" class="form-control" placeholder="amount.." [(ngModel)]="PaymentsConfig.minAmount">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-5 col-form-label">Payday <small>(every)</small></label>
                    <div class="col-lg-2 col-md-2 col-4">
                      <select id="payday" class="form-select" [(ngModel)]='PaymentsConfig.payday'>
                        <option value='Monday'>Monday</option>
                        <option value='Tuesday'>Tuesday</option>
                        <option value='Wednesday'>Wednesday</option>
                        <option value='Thursday'>Thursday</option>
                        <option value='Friday'>Friday</option>
                        <option value='Saturday'>Saturday</option>
                        <option value='Sunday'>Sunday</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-5 col-form-label">Payment $ fee for Wire method</label>
                    <div class="col-lg-1 col-md-2 col-2">
                        <input type="number" min="0" step="0.01" class="form-control" placeholder="fee.." [(ngModel)]="PaymentsConfig.feeWired">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-5 col-form-label">Payment $ fee for Payoneer method</label>
                    <div class="col-lg-1 col-md-2 col-2">
                        <input type="number" min="0" step="0.01" class="form-control" placeholder="fee.." [(ngModel)]="PaymentsConfig.feePayoneer">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-5 col-form-label">Payment $ fee for Paypal method</label>
                    <div class="col-lg-1 col-md-2 col-2">
                        <input type="number" min="0" step="0.01" class="form-control" placeholder="fee" [(ngModel)]="PaymentsConfig.feePaypal">
                    </div>
                  </div>

                </div>
                <div class="card-footer btn-showcase">
                  <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save configuration" (click)="onSave()">
                    Save</button>
                </div>
              </div>
            </div>
          </div>
          </ng-template>
        </ng-container>

      </div>
      <div [ngbNavOutlet]="nav" class="ms-4"></div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
